export enum AlbumTypeEnum {
  ATLAS,
  TRAINING, // formation
  RETROSPECTIVE_STUDY, // Etude rétrospective,
  PROSPECTIVE_STUDY, // Etudeprospective,
  OTHER
}

export interface AlbumAddOrUpdateInterface {
  id?: number | undefined;
  name: string;
  type: AlbumTypeEnum;
}
